var AdaptiveImage = require( "../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "ae5eeb7a48cac200d24cd5834773974a.png",
    width: 78,
    height: 78
});